import React from "react";

import { updateConfig } from "../../config/config";
import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../../constants/productTypes";
import { ToyotaLogo } from "./ToyotaLogo";
import "./theme.css";

updateConfig({
  HeaderAddons: () => <></>,
  LandingPageContent: () => <></>,
  Logo: () => <ToyotaLogo className="h-16 md:h-20 bg-primary bg-opacity-100" />,
  brandName: "Toyota",
  googleMapsMarkerSrc: "/static/img/toyota_v2/google_maps_marker.svg",
  landingPageImage: {
    [productTypeAccessory]: "/static/blocks/landing-accessories.png",
    [productTypePackage]: "/static/blocks/landing-packages.png",
    [productTypeTire]: "/static/blocks/landing-tires.png",
    [productTypeWheel]: "/static/blocks/landing-wheels.png",
  },
  productHeroBackground: null,
  themeClass: "toyota-theme",
});
